module.exports = __webpack_public_path__ + "img/interHover.5c0133b8.svg";